@if (!showConform) {
  <p class="info-text">{{ message | translate }}</p>
  <form>
    <div class="row">
      <div class="col-12">
        <div class="input-box">
          <label for="comment-textarea"> {{ 'conform_data_sec_holder_comment' | translate }} </label>
          <textarea
            id="comment-textarea"
            class="wall-new-msg"
            [formControl]="commentInput"
            name=""
            [placeholder]="'conform_data_sec_holder_placeholder_comment' | translate"
            cols="30"
            rows="15"
            [maxlength]="maxComment"
          ></textarea>

          @if (commentInput?.touched && commentInput?.hasError('maxlength')) {
            <p class="has-error">
              {{ 'hipotecas_error_maxLength' | translate: { maxLength: maxComment } }}
            </p>
          }
        </div>
      </div>
    </div>

    @if (modalComponent?.data?.error) {
      <p class="has-error">{{ modalComponent?.data?.error }}</p>
    }

    <button
      class="btn btn-02 btn-modal"
      type="submit"
      (click)="showConform = true"
      id="incorrect-data-modal-btn-continue"
    >
      {{ 'conform_data_sec_holder_btn_continue' | translate }}
    </button>
  </form>
} @else {
  <div>
    @if (modalComponent.data.type === 'deleteData') {
      <p class="info-text">
        {{ 'conform_data_sec_holder_confirm_delete_msg' | translate }}
      </p>
    }

    @if (modalComponent.data.type !== 'deleteData') {
      <p class="info-text">
        {{ 'conform_data_sec_holder_confirm_modify_msg' | translate }}
      </p>
    }

    <button
      class="btn btn-01 btn-modal"
      type="submit"
      (click)="showConform = false"
      id="incorrect-data-modal-btn-confirm-cancel"
    >
      {{ 'btn_cancel' | translate }}
    </button>
    <button
      class="btn btn-02 btn-modal"
      type="submit"
      (click)="sendForm()"
      id="incorrect-data-modal-btn-confirm-accepted"
    >
      {{ 'btn_aceptar' | translate }}
    </button>
  </div>
}
